import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import ShadowButton from './ShadowButton';

export default function Monthlies() {
  return (
    <div className="wrapper max-w-5xl mx-auto px-4 my-6 sm:my-32 opacity-0 animate-fade-in-up animation-delay-400">
      {/* Hero Section */}
      <div className="flex flex-col md:flex-row gap-8 mb-12">
        <div className="md:w-2/3 w-full">
          <div className="flex items-center gap-3 mb-4">
            <div 
              className="w-12 h-12 flex items-center justify-center rounded text-white font-bold"
              style={{ backgroundColor: '#E63946' }}
            >
              ML
            </div>
            <h1 className="text-3xl font-bold">Monthlies</h1>
          </div>
          <p className="text-xl font-medium mb-6">
            Validating and launching a menstrual care brand to the EU market.
          </p>
          
          <div className="flex flex-wrap gap-2 mb-8">
            {["MVP", "GTM", "Shopify", "Health", "D2C", "2022 - 2023"].map(tag => (
              <span key={tag} className="px-3 py-1 bg-gray-100 text-gray-800 rounded-full text-sm">
                {tag}
              </span>
            ))}
          </div>
        </div>
        
        <div className="md:w-2/4 w-full">
          <img 
            src="assets/project-image-monthlies.png" 
            alt="Monthlies project" 
            className="w-full h-auto rounded-3xl"
          />
        </div>
      </div>

      {/* Problem Section */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold mb-4 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 mr-2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5" />
            </svg>
          The challenge
        </h2>
        <p className="mb-4">
          Period pain is a huge problem, but the menstrual care industry is stuck in the past.
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2">
        <li>No effective natural alternatives for period pain</li>
        <li>Multiple products needed for complete pain relief</li>
        <li>Marketing that ignored women's real concerns</li>
        </ul>
      </div>


      {/* My Role Section */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold mb-4">My role</h2>
        <p className="mb-4">
          As venture architect and project lead:
        </p>
        
        <div className="space-y-6">
          <div>
          <h3 className="font-bold mb-2">Concept validation</h3>
<ul className="list-disc pl-6 space-y-2">
  <li>Built a multilingual store and quiz to survey 800+ women across Europe while doing presales, invalidating the initial concept</li>
  <li>Iterated through 5 different value propositions to find what actually resonated
</li>
</ul>
</div><div>
<h3 className="font-bold mb-2">Developing & scaling</h3>
<ul className="list-disc pl-6 space-y-2">
  <li>Partnered with health experts while leading a team of 8</li>
  <li>Rolled out to UK and Germany with refined messaging and offers</li>
  <li>Developed business model leading to seed funding</li>
</ul>
          </div>
        </div>
      </div>

      {/* Results Section */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold mb-4">Results</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="bg-gray-50 p-4 rounded-lg flex flex-col justify-center items-center text-center">
            <p className="text-2xl font-bold">800+</p>
            <p className="text-sm">Women surveyed</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg flex flex-col justify-center items-center text-center">
            <p className="text-2xl font-bold">1</p>
            <p className="text-sm">Succesful pivot</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg flex flex-col justify-center items-center text-center">
            <p className="text-2xl font-bold flex items-center justify-center mb-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 mr-2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
              </svg>
            </p>
            <p className="text-sm">Seed funding</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg flex flex-col justify-center items-center text-center">
            <p className="text-2xl font-bold flex items-center justify-center mb-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 mr-2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
              </svg>
            </p>
            <p className="text-sm">Customers</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg flex flex-col justify-center items-center text-center">
            <p className="text-2xl font-bold flex items-center justify-center mb-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 mr-2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
              </svg>
            </p>
            <p className="text-sm">Conversion rate</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg flex flex-col justify-center items-center text-center">
            <p className="text-2xl font-bold flex items-center justify-center mb-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 mr-2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
              </svg>
            </p>
            <p className="text-sm">Churn rate</p>
          </div>
        </div>
      </div>

      {/* Key Wins */}
<div className="mb-12">
  <h2 className="text-2xl font-bold mb-4">Key wins</h2>
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div className="bg-gray-50 p-4 rounded-lg flex">
      <svg className="w-6 h-6 mr-3 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
      </svg>
      <p>Gathered health data from 800+ women securely</p>
    </div>
    <div className="bg-gray-50 p-4 rounded-lg flex">
      <svg className="w-6 h-6 mr-3 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
      </svg>
      <p>Tested concepts in real Shopify stores before launch</p>
    </div>
    <div className="bg-gray-50 p-4 rounded-lg flex">
      <svg className="w-6 h-6 mr-3 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
      </svg>
      <p>Pivoted from subscription box to supplement</p>
    </div>
    <div className="bg-gray-50 p-4 rounded-lg flex">
      <svg className="w-6 h-6 mr-3 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
      </svg>
      <p>Helped raise seed funding based on strong validation data</p>
    </div>
  </div>
</div>

      {/* Technologies */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold mb-4">Technologies</h2>
        <div className="flex flex-wrap gap-2">
          {["Shopify", "ReCharge", "Klaviyo", "Octane AI", "Google Analytics", "Figma", "Miro"].map(tech => (
            <span key={tech} className="px-3 py-1 bg-gray-100 text-gray-800 rounded-full text-sm">
              {tech}
            </span>
          ))}
        </div>
      </div>

      <div className="my-24 bg-gray-100 p-12 rounded-lg">
      <h2 className="text-2xl text-center font-bold mb-4">Do you have a similar challenge and want to work with me?</h2>
  
  <div className="flex flex-col sm:flex-row gap-3 justify-center">
            {/* Using ShadowButton component */}
            <ShadowButton href="mailto:christophe@vaneerdt.be" fullWidth>
              Email me
            </ShadowButton>
            <ShadowButton href="tel:+32479706342" fullWidth>
              Call me
            </ShadowButton>
            <ShadowButton href="https://www.linkedin.com/in/cvaneerdt/" fullWidth>
              LinkedIn
            </ShadowButton>
          </div> 
     
</div>

      {/* Navigation */}
      <div className="flex justify-between items-center pt-6 border-t border-gray-200">
        <Link to="/kollegein" className="flex items-center gap-2 text-gray-600 hover:text-gray-900">
          <span className="w-8 h-8 flex items-center justify-center rounded text-white font-bold text-sm" style={{ backgroundColor: '#027D87' }}>
            KG
          </span>
          <span>Previous: Kollegin</span>
        </Link>
        
        <Link to="/routinely" className="flex items-center gap-2 text-gray-600 hover:text-gray-900">
          <span>Next: Routinely</span>
          <span className="w-8 h-8 flex items-center justify-center rounded bg-gray-600 text-white font-bold text-sm">
            RL
          </span>
        </Link>
      </div>
    </div>
  );
}